import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, H4 } from '@bigcommerce/big-design';

import { zoneDisable } from '../../redux/actions/zones';

const DisableZoneModal = ({ payload, zoneId, showDisableZoneModal, setShowDisableZoneModal, zone, disableZone }) => {
  const update = () => {
    disableZone(payload, zoneId);
    setShowDisableZoneModal(false);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => setShowDisableZoneModal(false),
        },
        { text: 'Disable Zone', onClick: () => update() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Disable Zone"
      isOpen={showDisableZoneModal}
      onClose={() => setShowDisableZoneModal(false)}
    >
      <H3>{zone?.label}</H3>
      <strong>Description</strong>: {zone?.description}
      <strong>Priority</strong>: {zone?.priority}
    </Modal>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  disableZone: (payload, zoneId) => dispatch(zoneDisable(payload, zoneId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DisableZoneModal);
